webpackJsonp([212839066777427],{

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: none;\n  color: #999;\n  margin-left: 0.5em;\n\n  @media (min-width: 520px) {\n    display: inline;\n  }\n'], ['\n  display: none;\n  color: #999;\n  margin-left: 0.5em;\n\n  @media (min-width: 520px) {\n    display: inline;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  list-style: none;\n'], ['\n  list-style: none;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-size: 1.8rem;\n  // text-decoration: none;\n  margin-bottom: 0.5em;\n'], ['\n  font-size: 1.8rem;\n  // text-decoration: none;\n  margin-bottom: 0.5em;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose([''], ['']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(21);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(137);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var DateSpan = _styledComponents2.default.span(_templateObject);
	
	var StyledBlogListing = _styledComponents2.default.ul(_templateObject2);
	
	var StyledBlogItem = _styledComponents2.default.li(_templateObject3);
	var StyledBlogLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject4);
	
	var BlogListing = function (_React$Component) {
	  _inherits(BlogListing, _React$Component);
	
	  function BlogListing() {
	    _classCallCheck(this, BlogListing);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlogListing.prototype.render = function render() {
	    var postLinks = this.props.posts.map(function (post) {
	      return _react2.default.createElement(
	        StyledBlogItem,
	        { key: post.node.fields.slug },
	        _react2.default.createElement(
	          StyledBlogLink,
	          { to: post.node.fields.slug },
	          post.node.frontmatter.title
	        ),
	        _react2.default.createElement(
	          DateSpan,
	          null,
	          '(',
	          post.node.frontmatter.date,
	          ')'
	        )
	      );
	    });
	
	    return _react2.default.createElement(
	      StyledBlogListing,
	      null,
	      postLinks
	    );
	  };
	
	  return BlogListing;
	}(_react2.default.Component);
	
	exports.default = BlogListing;
	module.exports = exports['default'];

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BlogListing = __webpack_require__(471);
	
	var _BlogListing2 = _interopRequireDefault(_BlogListing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogPage = function (_React$Component) {
	  _inherits(BlogPage, _React$Component);
	
	  function BlogPage() {
	    _classCallCheck(this, BlogPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlogPage.prototype.render = function render() {
	    try {
	      var posts = this.props.data.allMarkdownRemark.edges;
	      return _react2.default.createElement(_BlogListing2.default, { posts: posts });
	    } catch (e) {
	      console.log(e);
	      return _react2.default.createElement(
	        'h2',
	        null,
	        'Unable to find any blog posts.'
	      );
	    }
	  };
	
	  return BlogPage;
	}(_react2.default.Component);
	
	exports.default = BlogPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-bf476a906e2673ce7076.js